/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExceptionResponseWithRetryAfterDTO { 
    code?: number;
    message?: string;
    key?: string;
    retry_after_s?: number;
}

